import { useState, useEffect, useCallback } from "react";

import TableComponent from "../../Global Functions/tableComponents";
import { columnPlans } from "../../Global Functions/columnsAntd";
import AddPlan from "./addPlan";
import ViewPlan from "./ViewPlan";
import {
  viewPlanList,
  viewCurrentPlan,
} from "../../Redux/Actions/subscriptionActions";
import DateRangePopup from "../../Utils/dateFilterPopup";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
const ListPlan = () => {
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [showcurrentPlan, setShowCurrentPlan] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });
  const handleCurrentView = (data) => {
    dispatch(viewCurrentPlan(data));
    Navigate(`/Plan/view/${data}`);
  };
  const columns = columnPlans(handleCurrentView);

  const { planList } = useSelector((state) => state.plan);
  const { loading } = useSelector((state) => state.plan);

  const fetchDetails = useCallback(async (page, limit, showLoader = true) => {
    const planData = {
      page,
      limit,
      status: ["active", "inactive"],
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };
    try {
      await dispatch(viewPlanList(planData, showLoader));
      if (!showLoader) {
        // toast.success("User list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh user list");
      }
    }
  }, [dispatch, debouncedSearch, dateRange]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchDetails(pagination.current, pagination.pageSize);
    }, 150);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);


  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    if (planList?.data) {
      setPagination((prevData) => ({ ...prevData, total: planList?.data }));
    }
  }, [planList]);

  return (
    <div>
      {show && <AddPlan setShow={setShow} />}
      {showcurrentPlan && <ViewPlan setShow={setShowCurrentPlan} />}
      <TableComponent
        h3heading="Plans"
        setState={setSearchQuery}
        loading={loading}
        buttonhead2="Add Plan"
        navigateTo2={"/Plans/Add"}
        dataSource={
          (Array.isArray(planList?.data) && planList?.data) || []
        }
        onCalendarClick={() => setIsDatePopupVisible(true)}
        pagination={pagination}
        onChange={handleTableChange}
        columns={columns}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </div >
  );
};

export default ListPlan;
